<template>
    <div>
        <span class="text-danger">
            <i
                class="fa fa-minus-circle fa-lg icon-button"
                title="Remover item"
                @click.stop="removerItem()"
            ></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        itemRequisicao: {
            type: Object
        }
    },

    data() {
        return {}
    },

    methods: {
        removerItem() {
            this.$emit('removerItem', this.itemRequisicao)
        }
    },

    computed: {},

    created() {}
}
</script>
